import React from 'react';

const LeftArea: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className="left-area" >
            {children}
          </div>;
};

export default LeftArea;
